<app-icon [name]="iconName()"></app-icon>
<div class="w-full text-base">

  <ng-content></ng-content>

</div>
<app-icon size="small" name="heroChevronRightMini" class="text-gray items-center"></app-icon>
